import { Action } from '@ngrx/store';
import { RoleModel } from '../../models/RoleModel';

export const REMOVE_ROLE_FROM_ROLE_SUCCESS = '[Security] Role Remove Role Success';

export class RemoveRoleFromRoleSuccessAction implements Action {
  readonly type = REMOVE_ROLE_FROM_ROLE_SUCCESS;

  constructor(public payload: { roleKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/RemoveRoleFromRoleSuccessAction.ts